import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Typography } from "@mui/material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import { ServiceOffer, serviceOptions, ServiceType } from "../../common/const";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getUpComingExamList } from "../../api/examApi";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { getUpcomingSession } from "../../api/sessionApi";
import { getUpcomingMeeting } from "../../api/adminMeetingApi";

const UpcomingEvents = () => {
    const dispatch = useDispatch();
    const { loading, user } = useSelector((state) => state.auth);
    const [selectedEvent, setSelectedEvent] = useState('meetings');
    const [upcomingExams, setUpcomingExams] = useState([]);
    const [upcomingMeeting, setUpcomingMeeting] = useState([]);
    const [imageUrls, setImageUrls] = useState({});

    const getUpComingExam = async () => {
        try {
            dispatch(setLoading({ loading: true }));
            const response = await getUpComingExamList(user?.student_id);
            setUpcomingExams(response.data);
            dispatch(setLoading({ loading: false }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message ||
                err.response?.data?.message ||
                err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({ loading: false }));
        }
    }

    const getEvents = async (counsellor) => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getUpcomingSession(counsellor ? ServiceOffer.counsellor : ServiceType.filter((a) => a.value !== ServiceOffer.counsellor)?.map((a) => a.value)?.join(','), user?.student_id, '');
            setUpcomingExams(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    const getUpcomingMeetings = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getUpcomingMeeting();
            setUpcomingMeeting(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            if (selectedEvent === 'exams') {
                getUpComingExam();
            } else if (selectedEvent === 'mentorappointment') {
                getEvents('counsellor');
            } else if (selectedEvent === 'classes') {
                getEvents();
            } else {
                getUpcomingMeetings();
            }
        }
    }, [user, selectedEvent]);

    const loadImageAsBlob = async (avatarPath, userId) => {
        try {
            const fullUrl = `${process.env.REACT_APP_BASE_URL}/file?bname=${avatarPath}&download=false`;
            const response = await fetch(fullUrl, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);

            setImageUrls(prev => ({
                ...prev,
                [userId]: objectUrl
            }));
        } catch (error) {
            console.error('Error loading image:', error);
        }
    };

    // Load all images when mentors are set
    useEffect(() => {
        if (upcomingMeeting?.length > 0) {
            upcomingMeeting?.map(meeting => {
                if (meeting.image_url?.url && !imageUrls[meeting?.meeting_id]) {
                    loadImageAsBlob(meeting?.image_url?.url, meeting?.meeting_id);
                }
            });
        }
    }, [upcomingMeeting]);


    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>Upcoming Events</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>Keep track of scheduled events and sessions.</Typography>
                            </Box>
                            <Box
                                display="flex"
                                gap={1}
                                alignItems="center"
                            >
                                <CommonButton
                                    label="Meetings"
                                    marginBottom="0px"
                                    width="100px"
                                    background={selectedEvent === 'meetings' ? theme.palette.primary.main : theme.palette.background.main}
                                    color={selectedEvent === 'meetings' ? theme.palette.secondary.main : theme.palette.background.dark}
                                    fontWeight={selectedEvent === 'meetings' ? 600 : 100}
                                    handleClick={() => setSelectedEvent('meetings')}
                                />
                                <CommonButton
                                    label="Mentor Appointments"
                                    marginBottom="0px"
                                    width="200px"
                                    background={selectedEvent === 'mentorappointment' ? theme.palette.primary.main : theme.palette.background.main}
                                    color={selectedEvent === 'mentorappointment' ? theme.palette.secondary.main : theme.palette.background.dark}
                                    fontWeight={selectedEvent === 'mentorappointment' ? 600 : 100}
                                    handleClick={() => setSelectedEvent('mentorappointment')}
                                />
                                <CommonButton
                                    label="Exams"
                                    marginBottom="0px"
                                    width="100px"
                                    background={selectedEvent === 'exams' ? theme.palette.primary.main : theme.palette.background.main}
                                    color={selectedEvent === 'exams' ? theme.palette.secondary.main : theme.palette.background.dark}
                                    fontWeight={selectedEvent === 'exams' ? 600 : 100}
                                    handleClick={() => setSelectedEvent('exams')}
                                />
                                <CommonButton
                                    label="Classes"
                                    marginBottom="0px"
                                    width="100px"
                                    background={selectedEvent === 'classes' ? theme.palette.primary.main : theme.palette.background.main}
                                    color={selectedEvent === 'classes' ? theme.palette.secondary.main : theme.palette.background.dark}
                                    fontWeight={selectedEvent === 'classes' ? 600 : 100}
                                    handleClick={() => setSelectedEvent('classes')}
                                />
                            </Box>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    selectedEvent === 'exams' || selectedEvent === 'mentorappointment' || selectedEvent === 'classes' ? (
                        upcomingExams.length > 0 ?
                            (<Box
                                sx={{
                                    height: '31vh',
                                    overflow: 'auto'
                                }}
                            >
                                {upcomingExams.map((a, index) => {
                                    return (
                                        <Fragment key={index}>
                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                padding="10px"
                                            >
                                                <Box
                                                    width="80%"
                                                    display="flex"
                                                    alignItems="center"
                                                    gap={1.5}
                                                >
                                                    <Box
                                                        sx={{
                                                            background: theme.palette.secondary.main,
                                                            borderRadius: 1,
                                                            padding: 1
                                                        }}
                                                    >
                                                        <Typography fontSize={18} fontWeight={600} color={theme.palette.primary.main} textAlign="center">{moment(a.exam_date || a.session_start_time).date()}</Typography>
                                                        <Typography fontSize={12} fontWeight={600} color="white">{moment(a.exam_date || a.session_start_time).format('MMM YYYY')}</Typography>
                                                    </Box>
                                                    {a.subjects?.length > 0 ? (
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight="600">{a.subjects
                                                                .map(s => s.name)
                                                                .sort((a, b) => a - b)[0]}</Typography>
                                                        </Box>
                                                    ) : (
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight="600">{a.test_type || a.topic || serviceOptions?.find((i) => i.value === a.service_name)?.label}</Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </Box>
                                            {(index !== upcomingExams.length - 1) && (
                                                <Divider />
                                            )}
                                        </Fragment>
                                    )
                                })}
                            </Box>) : (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    p={2}
                                >
                                    <Typography color={theme.palette.background.dark}>No Exam/Deadlines Found</Typography>
                                </Box>
                            )
                    ) : upcomingMeeting?.length > 0 ? (
                        <Box
                            sx={{
                                height: '31vh',
                                overflow: 'auto'
                            }}
                        >
                            {upcomingMeeting.map((a, index) => {
                                return (
                                    <Fragment key={index}>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            padding="10px"
                                        >
                                            <Box
                                                width="80%"
                                                display="flex"
                                                alignItems="center"
                                                gap={1.5}
                                            >
                                                <Box
                                                    sx={{
                                                        background: theme.palette.secondary.main,
                                                        borderRadius: 1,
                                                        padding: 1
                                                    }}
                                                >
                                                    <Typography fontSize={18} fontWeight={600} color={theme.palette.primary.main} textAlign="center">{moment(a.meeting_datetime).date()}</Typography>
                                                    <Typography fontSize={12} fontWeight={600} color="white">{moment(a.meeting_datetime).format('MMM YYYY')}</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography fontSize={15} fontWeight="600">{a.title}</Typography>
                                                    <Typography fontSize={13} color={theme.palette.background.dark}>{a.description}</Typography>
                                                </Box>
                                            </Box>
                                            {a.image_url && (
                                                <img src={imageUrls[a?.meeting_id]} alt="event" height="60px" width="100px" style={{ borderRadius: 8 }} />
                                            )}
                                        </Box>
                                        {(index !== upcomingMeeting.length - 1) && (
                                            <Divider />
                                        )}
                                    </Fragment>
                                )
                            })}
                        </Box>
                    ) : (
                        <Box
                            display="flex"
                            justifyContent="center"
                            p={2}
                        >
                            <Typography color={theme.palette.background.dark}>No upcoming meetings scheduled</Typography>
                        </Box>
                    )
                }
                paddingBottom="0px"
                padding="0px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default UpcomingEvents;